export const baseUrl = 'https://www.10gtek.com';
// export const baseUrl = 'http://127.0.0.1:8000';
//判断链接是否返回空值
export function urlFormat(url){
  if(url == '' || url == null){ return ''; }
  else{ return url; }
}
//判断图片路径如果返回null则替换
export function imgFormat(url){
  if(url == '' || url == null){ return require('../images/placeholder.jpg'); }
  else{ return baseUrl+url; }
}
//设置浏览器标题
export const setTitle = function(title) {
  title = title ? `${title}` : '10gtek'
  window.document.title = title
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js